import axios from "axios";
import { API_BASE_URL } from "../config/api";

export const normalizePincode = (value = "") =>
  String(value || "").replace(/\D/g, "").slice(0, 6);

export const fetchLocationByPincode = async (value) => {
  const pincode = normalizePincode(value);

  if (!/^\d{6}$/.test(pincode)) {
    throw new Error("Enter a valid 6-digit pincode.");
  }

  const response = await axios.get(`${API_BASE_URL}/get-location/${pincode}`);

  return {
    city: String(response.data?.city || "").trim(),
    state: String(response.data?.state || "").trim()
  };
};
